import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = 'https://cotizaciones-fabrica-rivera-production.up.railway.app/api';

export default function AutoLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const loginAutomatico = async () => {
      try {
        const token = params.get('token');
        const cotizacionId = params.get('id');
        const nombre = params.get('nombre');
        const userId = params.get('userId');

        if (!token) {
          navigate('/login');
          return;
        }

        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('PAYLOAD TOKEN:', payload);

        const res = await axios.get(`${API}/auth/verificar`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        console.log('USUARIO VERIFICADO:', res.data.usuario);

        localStorage.clear();

        localStorage.setItem('token', token);
        localStorage.setItem(
          'usuario',
          JSON.stringify(res.data.usuario)
        );

        if (nombre) {
          localStorage.setItem('nombre', nombre);
        }

        if (userId) {
          localStorage.setItem('userId', userId);
        }

        console.log(
          'USUARIO GUARDADO:',
          localStorage.getItem('usuario')
        );

        navigate(`/cotizacion/${cotizacionId}`);

      } catch (err) {
        console.error('ERROR AUTOLOGIN:', err);
        navigate('/login');
      }
    };

    loginAutomatico();
  }, [navigate, params]);

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      Iniciando sesión...
    </div>
  );
}